import Icon from '../components/Icon';

const LockOpen = Icon(
  'lock-open',
  <>
    <path d="M12 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
    <path
      fillRule="evenodd"
      d="M10.9 2.895a4.25 4.25 0 0 1 4.78 1.98.75.75 0 1 0 1.3-.75A5.75 5.75 0 0 0 6.25 7v2.25H5A2.75 2.75 0 0 0 2.25 12v8A2.75 2.75 0 0 0 5 22.75h14A2.75 2.75 0 0 0 21.75 20v-8A2.75 2.75 0 0 0 19 9.25H7.75V7a4.25 4.25 0 0 1 3.15-4.105M19 10.75c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25v-8c0-.69.56-1.25 1.25-1.25z"
      clipRule="evenodd"
    />
  </>
);

export default LockOpen;
